export const QUESTION_ANCHOR_PREFIX = 'question';
export const ANSWER_ANCHOR_PREFIX = 'answer';
